import { Autocomplete, Dialog, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from "react";
import { getBankAccounts } from "../API/nimble";
import { useLoaderData } from "react-router-dom";
 
 
const AddNewPurpose = ({ open, onClose, corporation, savePurpose }) => {
 
    const { corporations, UserName, authId, urlInfo, menuID, headerCrpId,preferences,clientNameUrlVersion } = useLoaderData();
 
    const addNewURL = process.env.REACT_APP_ADD_NEW;
    const addNewURL_V2 = process.env.REACT_APP_ADD_NEW_V2;
 
    useEffect(() => {
       
 
        const handleMessage = (event) => {
            if (event.data && event.data.closePopup) {
                savePurpose();
                onClose();
            }
        };
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
 
    const crp = preferences.isLegalName ? corporation.LegalName : corporation.Name
 
    const url =
  clientNameUrlVersion === "v2"
    ? addNewURL_V2
    : addNewURL;
 
 
    // const newUrl = `${addNewURL}/false/${corporation.ID}/${corporation.Name}/false/${urlInfo}/${authId}/11211`
    const newUrl = `${url}/false/${corporation.ID}/${crp}/false/${urlInfo}/${authId}/11211`
    return (
        <Dialog open={open}  fullScreen
            // PaperProps={{
            //     sx: {
            //         height: "90vh",
            //     },
            // }}
            >
            <DialogTitle bgcolor={"#f4f5f8"} fontSize={15} fontWeight={600} color="#4c82ec" >Add New Purpose Name</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                // onClick={() => {
                //     savePurpose();
                //     onClose();
                // }}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <iframe src={newUrl} height={"100%"} width={"100%"}
                    style={{
                        border: "none",
                        // transform: "scale(1.05)",
                        // transformOrigin: "0 0",
                    }} />
 
            </DialogContent>
 
        </Dialog >
    )
};
 
export default AddNewPurpose;